import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./Home.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import RookTech from "../../images/rook-no-bg.png";
import RookTechIcon from "../../images/RookTechIcon.png";

const HomePage = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.pageWrapper}>
      <Navbar />
      <main className={styles.home}>
        <div className={styles.heroSection}>
          <img
            className={styles.backgroundImage}
            src={RookTech}
            alt="Rook Tech tower"
          />
          <div className={styles.homeContainer}>
            <p className={styles.homeSubtitles}>{t("home.welcome")}</p>

            <div className={styles.homeTextContainer}>
              <img
                className={styles.homeIcon}
                src={RookTechIcon}
                alt="RookTech Icon"
              />
              <h2 className={styles.homeTitle}>Rook Tech</h2>
            </div>

            <p className={styles.homeSubtitles}>{t("home.subtitle")}</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
